import { useAuth } from "../../../context/AuthContext";
import { useCart } from "../../../context/CartContext";
import UserDesktopNavbar from "./UserDesktopNavbar";
import UserMobileNavbar from "./UserMobileNavbar";
import {
    DEFAULT_USER_NAVBAR_PROFILE,
    UserNavbarProfile,
} from "./UserNavbarData";
import "./UserNavbar.css";

type UserNavbarProps = {
    companyName?: string;
    cartCount?: number;
    cartTotal?: number;
    notificationCount?: number;
    messageCount?: number;
    profile?: UserNavbarProfile;
    onMenuClick?: () => void;
    menuOpen?: boolean;
};

const UserNavbar = ({
    companyName = "SWORLDS SOLUTIONS PVT LTD",
    cartCount: propCartCount,
    cartTotal: propCartTotal,
    notificationCount = 0,
    messageCount = 0,
    profile: propProfile,
    onMenuClick,
    menuOpen = false,
}: UserNavbarProps) => {
    const { user } = useAuth();
    const { cartCount: ctxCartCount, cartTotal: ctxCartTotal } = useCart();

    const cartCount = propCartCount !== undefined ? propCartCount : ctxCartCount;
    const cartTotal = propCartTotal !== undefined ? propCartTotal : ctxCartTotal;

    const dynamicProfile: UserNavbarProfile = {
        name:
            user?.fullName ||
            user?.name ||
            (user?.email ? user.email.split("@")[0] : propProfile?.name || DEFAULT_USER_NAVBAR_PROFILE.name),
        userId:
            user?.registerId ||
            propProfile?.userId ||
            DEFAULT_USER_NAVBAR_PROFILE.userId,
        email:
            user?.email ||
            user?.emailId ||
            propProfile?.email ||
            "",
        image:
            user?.profilePicture ||
            propProfile?.image ||
            "",
        initial:
            (user?.fullName || user?.name || user?.email || "")?.trim()?.charAt(0)?.toUpperCase() ||
            propProfile?.initial ||
            "S",
    };

    return (
        <>
            <UserDesktopNavbar
                companyName={companyName}
                cartCount={cartCount}
                cartTotal={cartTotal}
                notificationCount={notificationCount}
                messageCount={messageCount}
                profile={dynamicProfile}
                onMenuClick={onMenuClick}
                menuOpen={menuOpen}
            />

            <UserMobileNavbar
                companyName={companyName}
                cartCount={cartCount}
                cartTotal={cartTotal}
                notificationCount={notificationCount}
                messageCount={messageCount}
                profile={dynamicProfile}
                onMenuClick={onMenuClick}
                menuOpen={menuOpen}
            />

            <div
                className="user-module-navbar-spacer"
                aria-hidden="true"
            />
        </>
    );
};

export default UserNavbar;
